import { render, staticRenderFns } from "./medicalDeviceInfo.vue?vue&type=template&id=517d6258&scoped=true&"
import script from "./medicalDeviceInfo.vue?vue&type=script&lang=js&"
export * from "./medicalDeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./medicalDeviceInfo.vue?vue&type=style&index=0&id=517d6258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d6258",
  null
  
)

export default component.exports